
import Vue from 'vue'
import equipmentV2 from '../../store/modules/equipmentV2'
import { mapActions, mapState, mapMutations } from 'vuex'
export default Vue.extend({
  data () {
    return {
      // activeTitle: ''
    }
  },
  watch: {

  },
  computed: {
    ...mapState(equipmentV2, ['equipmentData'])
  },
  created () {
    // this.getEnterprise()
  },
  async mounted () {
    this.judgeChooseBase()
  },
  methods: {
    ...mapActions(equipmentV2, ['getEquipmentsData', 'getEnterprise']),
    ...mapMutations(equipmentV2, ['setEquipmentsData']),
    // 获取设备数据
    async getEquipmentData (obj, bool = false) {
      await this.getEquipmentsData({
        FishBaseId: obj.fishBaseId,
        FishPondId: obj.fishPondId,
        IsGetRealTimeData: bool
      })
    },
    // 判断是否曾选择过基地
    judgeChooseBase () {
      let obj
      let data = localStorage.getItem('currentBasic')
      if (data) {
        obj = JSON.parse(data)
      }
      if (!obj) {
        if (this.$route.name === 'equipmentControl') {
          this.$router.push({
            name: 'basicList'
          })
        }
      }
    }
  }
})
